<div class="container px-0" [class.light-gray-bg]="Utility.mobile" #listContainer>
  <div class="row mx-0">
    <div class="col d-md-block px-0" [class.d-none]="detailId" [class.col-4]="detailId" [class.col-12]="!detailId">
      <div class="container p-0">
        <div class="row m-0" style="direction: rtl;">
          <div class="col py-2">
            <ng-container *ngIf="total">
              <ng-template #resultsHeaderText>
                <h2 *ngIf="page==1" class="fs-sm m-0">
                  {{total|number}} آگهی استخدام {{criteria.Keyword}}
                  <ng-container *ngIf="criteria.State">در
                    {{[criteria.State,criteria.City,criteria.District]|join:'، '}}
                  </ng-container>
                </h2>
                <h2 *ngIf="page>1" class="fs-sm m-0">صفحه {{page|number}} از {{total|number}} آگهی استخدام
                  {{criteria.Keyword}}</h2>
              </ng-template>
              <ng-container *ngIf="showResultsHeader">
                <div class="mb-3 badge-pill light-gray-bg p-1 text-center" *ngIf="!Utility.mobile">
                  <ng-container *ngTemplateOutlet="resultsHeaderText"></ng-container>
                </div>
                <div class="mb-3 btn btn-white w-100" *ngIf="Utility.mobile"
                  (click)="sharedService.scrollIntoView('.jobs-container .scroll-anchor')">
                  <ng-container *ngTemplateOutlet="resultsHeaderText"></ng-container>
                </div>
              </ng-container>
            </ng-container>
            <div *ngIf="jobs && !jobs.length" class="fs-sm">
              متاسفانه هیچ فرصت شغلی برای این جستجو یافت نشد.
            </div>
          </div>
        </div>
        <div class="row m-0" style="direction: rtl;">
          <div class="col px-0 jobs-container job-list-scroll relative" infiniteScroll (scrolled)="loadMore()">
            <ngx-spinner name="list" [fullScreen]="false"></ngx-spinner>
            <div class="scroll-anchor"></div>
            <ng-container *ngFor="let job of jobs; let i=index">
              <!-- <div class="list-spliter fs-sm f-gray" *ngIf="i && i%10==0"> آگهی {{i|number}} ام 🡅</div> -->
              <div class="container rounded-xl white-bg p-3 mb-3 shadow-kp pointer"
                [class.shadow-kp-raised]="detailId=='content'" [class.border]="detailId=='content'"
                [class.border-medium-gray]="detailId=='content'" (click)="open('content')" *ngIf="seoContent && i==9">
                <div class="row">
                  <div class="col-12" style="max-height: 170px; overflow: hidden;">
                    <h3 class="fs-lg f-initial mt-2">{{seoContent.Title}}</h3>
                    <p [innerHTML]="seoContent.Body" class="fs-sm lh-sm p-0"></p>
                    <span class="yellow-bg rounded-xl  white-bg px-3 fs-normal shadow-kp"
                      style="position: absolute; bottom: 0; left: 10px; ">بیشتر بخوانید...</span>
                  </div>
                </div>
              </div>

              <app-job-summary [job]="job" [selected]="job.Id==detailId" [favorite]="favoriteIds.includes(job.Id)"
                (toggleFavorite)="setFavorite(job)" [newDate]="newDate">
              </app-job-summary>


            </ng-container>
            <div style="position: relative;height:30px;">
              <ngx-spinner name="more" [fullScreen]="false" bdColor="rgba(0,0,0,0)" color="gray" type="square-jelly-box"
                size="small"></ngx-spinner>
            </div>


            <section class="container">
              <section class="" *ngIf="nearbyJobs?.length">
                <div class="list-nearby"> آگهی‌های نزدیک به جستجوی شما 🡇</div>
                <ng-container *ngFor="let job of nearbyJobs; let i=index">
                  <app-job-summary [job]="job" [selected]="job.Id==detailId" [favorite]="favoriteIds.includes(job.Id)"
                    (toggleFavorite)="setFavorite(job)" [newDate]="newDate">
                  </app-job-summary>
                </ng-container>
              </section>
              <!-- <img *ngIf="jobSearchLink" [src]="jobSearchLink" width="1px" height="1px" /> -->
            </section>

          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-8 mr-auto px-0" [class.d-none]="!detailId">
      <div class=" scroll-lg job-detail" [class.sticky]="!Utility.mobile" [attr.style]="detailStyle"
        [class.overflow-y-auto]="!Utility.mobile">
        <div class="h-100 pb-2 white-bg rounded-xl mx-md-2">
          <app-job-detail *ngIf="detailId && detailId!='content'" [job-id]="detailId"
            [favorite]="favoriteIds?.includes(detailId)" (favoriteChange)="setFavorite(detailId, $event)">
          </app-job-detail>
          <div *ngIf="detailId=='content'">
            <section class="container px-4 px-md-2 py-2">
              <div class="row m-0">
                <div class="col col p-0 rounded-xl  white-bg" [class.shadow-kp]="!Utility.mobile">
                  <div class="container p-0">
                    <section class="row">
                      <div class="col-12">
                        <div class="container dark-gray-bg   f-white pt-5 pb-2 px-3  mb-3"
                          [class.shadow-kp]="Utility.mobile" [class.rounded-xl]="Utility.mobile"
                          [class.rounded-top-xl]="!Utility.mobile">
                          <h1>{{seoContent.Title}}</h1>
                        </div>
                      </div>
                    </section>
                    <section class="row m-0">
                      <div class="col">
                        <p [innerHtml]="seoContent.Body"></p>
                      </div>
                    </section>

                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>